import {
  ARC_END_ANGLE,
  ARC_OUTER_RADIUS_PERCENTAGE,
  GAUGE_VERTICAL_DEFAULT_OFFSET,
  GAUGE_VERTICAL_SMALL_OFFSET,
  MIN_MAX_PADDING,
} from '../constants.js';
import { useGaugeChartSizeContext } from './useGaugeChartSizeContext.js';

// Precomputed: vertical factor of the arc endpoints relative to center.
const ARC_ENDPOINT_Y_FACTOR = -Math.cos(ARC_END_ANGLE);
const LABEL_HEIGHT_BUFFER = 20;

export const useGaugeChartTooltipOverlayBounds = ():
  | { top: number; left: number; width: number; height: number }
  | undefined => {
  const dimensions = useGaugeChartSizeContext();
  if (!dimensions?.width || !dimensions?.height) {
    return undefined;
  }

  const { width, height } = dimensions;
  const verticalOffset =
    height > width
      ? height * GAUGE_VERTICAL_SMALL_OFFSET
      : height * GAUGE_VERTICAL_DEFAULT_OFFSET;
  const arcOuterRadius =
    (Math.min(width, height) / 2) * ARC_OUTER_RADIUS_PERCENTAGE;
  const centerY = height / 2 + verticalOffset;

  return {
    top: centerY - arcOuterRadius,
    left: width / 2 - arcOuterRadius,
    width: 2 * arcOuterRadius,
    height:
      arcOuterRadius * (1 + ARC_ENDPOINT_Y_FACTOR) +
      MIN_MAX_PADDING +
      LABEL_HEIGHT_BUFFER,
  };
};
